/*
 * Blocks navigation while the user must update the contact email address
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2026 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import {
  Router,
  UrlTree
} from '@angular/router';
import { ContactEmailService } from 'app/shared/services/contact-email.service';

@Injectable ( {
  providedIn: 'root'
} )
export class ContactEmailGuard {

  constructor (
    private router: Router,
    private contactEmailService: ContactEmailService,
  ) {
  }

  canActivate (): boolean | UrlTree {
    return this.contactEmailService.isUpdateRequired ? this.router.createUrlTree ( [ '/update-email' ] ) : true;
  }
}
